<div class="mb-3" *ngIf="visible">
  <div class="alert alert-info py-2 small mb-3">
    <i class="fas fa-link me-1"></i>
    Contrato B2B: selecione contrato e veículo/condutor. A OS/orçamento pode ser aberta depois, na chegada.
  </div>

  <label class="form-label">Contrato B2B</label>
  <select class="form-select mb-2"
    [(ngModel)]="booking.selectedContractId"
    (ngModelChange)="booking.onContractChange()"
    [disabled]="booking.loadingContracts || booking.contracts.length === 0">
    <option [ngValue]="null" disabled>Selecione o contrato...</option>
    <option *ngFor="let c of booking.contracts" [ngValue]="c.id">
      {{ c.contractNumber || c.id }} — {{ c.companyName || c.contractName || 'Contrato' }}
    </option>
  </select>
  <div *ngIf="booking.loadingContracts" class="text-muted small mb-2">
    <i class="fas fa-spinner fa-spin me-1"></i> Carregando contratos...
  </div>

  <label class="form-label">Veículo / condutor</label>
  <select class="form-select mb-2"
    [(ngModel)]="booking.selectedSnapshotId"
    (ngModelChange)="booking.onVehicleChange()"
    [disabled]="!booking.selectedContractId || booking.loadingFleet || booking.fleetVehicles.length === 0">
    <option [ngValue]="null" disabled>Selecione o veículo da frota...</option>
    <option *ngFor="let v of booking.fleetVehicles" [ngValue]="v.snapshotId">
      {{ v.label }}
    </option>
  </select>
  <div *ngIf="booking.loadingFleet" class="text-muted small mb-2">
    <i class="fas fa-spinner fa-spin me-1"></i> Carregando frota...
  </div>

  <div *ngIf="booking.hint" class="alert alert-warning py-2 small mb-0">
    <i class="fas fa-exclamation-triangle me-1"></i>{{ booking.hint }}
  </div>
</div>
